import { render, staticRenderFns } from "./userNotice.vue?vue&type=template&id=359f9027&"
import script from "./userNotice.vue?vue&type=script&lang=js&"
export * from "./userNotice.vue?vue&type=script&lang=js&"
import style0 from "./userNotice.vue?vue&type=style&index=0&id=359f9027&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports